(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'ReservationAddLink',
	};

	$(document).ready(function _ready() {
		Adzuki.onload('/Reservations/link', function _onload() {
			Adzuki.Form.registerForm(form);
		});
	});

	form.load = function onFormLoad()
	{
		$('[id^="reservationaddlink-link_to_reservations"]').click(function linkReservation()
		{
			var $self   = $(this),
			    $select = $self.parents('.table-row').find('select');

			$select.attr('disabled', !$self.is(':checked'));
		});
	};

}(jQuery, window.Adzuki || {}));
